import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { StepPageRoutingModule } from "./step-routing.module";
import { StepPage } from "./step.page";
import { ChallengeLayoutModule } from "src/app/components/challenge-layout/challenge-layout.module";
import { TranslateModule } from "@ngx-translate/core";
import { IsLastStepOfChallengePipeModule } from "src/app/pipes/is-last-step-of-challenge/is-last-step-of-challenge.module";
import { BackgroundImageDirectiveModule } from "src/app/directives/background-image/background-image.module";
import { LearningModulesDefaultImageModule } from "src/app/pipes/learning-modules-default-image/learning-modules-default-image.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    StepPageRoutingModule,
    ChallengeLayoutModule,
    IsLastStepOfChallengePipeModule,
    IsLastStepOfChallengePipeModule,
    TranslateModule,
    BackgroundImageDirectiveModule,
    LearningModulesDefaultImageModule,
  ],
  declarations: [StepPage],
})
export class StepPageModule {}
